module.exports = __webpack_public_path__ + "static/media/account.56a2253a.svg";